// Import Firebase core
import { initializeApp } from "firebase/app";

// Import Firebase Auth
import { getAuth } from "firebase/auth";

// Optional: Analytics
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDNbCPORlXzZfcKskkfxMaTl_CmEf6ICwI",
  authDomain: "the3dcreatorapp.firebaseapp.com",
  projectId: "the3dcreatorapp",
  storageBucket: "the3dcreatorapp.firebasestorage.app",
  messagingSenderId: "195135879148",
  appId: "1:195135879148:web:44b2afe0197b1c050f32c9",
  measurementId: "G-JNXT6DCR4G"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Auth (IMPORTANT)
export const auth = getAuth(app);

// Optional Analytics
export const analytics = getAnalytics(app);

export default app;
